// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__wrfrU","calendarButtons":"ClockData_calendarButtons__15Nus"};